import Footer from "../ones/Footer";
import ServicesContent from "../ones/ServicesContent";

export default function ResourcesLanding() {
  return (
    <>
      <ServicesContent />
      <Footer />
    </>
  );
}
